import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SupportLanding from './SupportLanding';
import TicketStatus from './TicketStatus';

const SupportPortal = () => {
  return (
    <Routes>
      <Route path="/" element={<SupportLanding />} />
      <Route path="/status" element={<TicketStatus />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default SupportPortal;
